import React from "react";
import RichHtml from "@/components/RichHtml";
import { ShieldCheck, FileBadge } from "lucide-react";

export function hasLicensing(licensing) {
  if (!licensing) return false;
  const hasHtml = (licensing.html || "").replace(/<[^>]+>/g, "").trim().length > 0;
  const nums = Array.isArray(licensing.registration_numbers)
    ? licensing.registration_numbers.filter((r) => r && (r.label || r.value)).length > 0
    : false;
  return hasHtml || nums;
}

export default function LicensingBlock({ licensing, testId = "licensing-block" }) {
  if (!hasLicensing(licensing)) return null;
  const nums = (licensing.registration_numbers || []).filter((r) => r && (r.label || r.value));
  return (
    <section data-testid={testId} className="rounded-3xl bg-soft-gray border border-navy-50 p-8 lg:p-10">
      <div className="flex items-center gap-2">
        <ShieldCheck className="h-5 w-5 text-teal" />
        <h2 className="text-[11px] uppercase tracking-[0.22em] font-semibold text-navy-500">
          Licensing &amp; registration
        </h2>
      </div>
      {(licensing.html || "").replace(/<[^>]+>/g, "").trim() && (
        <div className="mt-6 max-w-3xl">
          <RichHtml html={licensing.html} testId={`${testId}-body`} />
        </div>
      )}
      {nums.length > 0 && (
        <ul className="mt-8 grid gap-4 md:grid-cols-2 lg:grid-cols-3">
          {nums.map((r, i) => (
            <li key={i} className="flex items-start gap-3 p-5 rounded-2xl bg-white border border-navy-50" data-testid={`${testId}-reg-${i}`}>
              <FileBadge className="h-4 w-4 text-teal shrink-0 mt-1" />
              <div>
                <p className="text-[11px] uppercase tracking-[0.22em] text-navy-500 font-semibold">
                  {r.label || "Registration"}
                </p>
                <p className="mt-1 font-semibold text-navy-800 break-all">{r.value || "—"}</p>
                {r.issuer && <p className="mt-1 text-xs text-navy-500">{r.issuer}</p>}
              </div>
            </li>
          ))}
        </ul>
      )}
    </section>
  );
}

export function LicensingMicrotext({ licensing }) {
  if (!hasLicensing(licensing)) return null;
  const nums = (licensing.registration_numbers || []).filter((r) => r && r.value);
  if (!nums.length) return null;
  return (
    <p className="text-[11px] text-white/55" data-testid="footer-licensing">
      {nums.map((r) => `${r.label || "Reg."} ${r.value}`).join(" · ")}
    </p>
  );
}
